export default function relativeTime(commentDateInfo) {
  // retrieves relative time from API for comments
  const daysToToday =
    Math.abs(new Date() - new Date(commentDateInfo)) / 86400000;
  //convert javascript date objects to one day
  if (daysToToday < 1 / 24) {
    return Math.round(daysToToday * 1440) + " minutes ago.";
  } else if (daysToToday < 1) {
    return (daysToToday * 24).toPrecision(2) + " hours ago.";
  } else if (daysToToday < 30) {
    return daysToToday.toPrecision(2) + " days ago.";
  } else if (daysToToday < 365) {
    return ((daysToToday / 365) * 12).toPrecision(2) + " months ago.";
  } else {
    return (daysToToday / 365).toPrecision(2) + " years ago.";
  }
}
